import React from 'react';
import { Icon } from '@reverse-hr/design-system';
import { useTranslation } from 'react-i18next';
import { MotivationIcons } from '@app/constants/candidate';

const MotivationToChange = props => {
  const { candidateMotivationToChange } = props;
  const { t } = useTranslation();

  const renderMotivationToChange = () =>
    candidateMotivationToChange ? (
      <>
        <Icon name={MotivationIcons[candidateMotivationToChange]} size={20} />
        <p className="c-app-showcase__motivation-text capitalize">
          {t(
            `showcase.motivationToChangeValues.${candidateMotivationToChange}`,
          )}
        </p>
      </>
    ) : null;

  return (
    <td className="c-app-showcase__cell c-app-showcase__cell--center-aligned">
      <div className="c-app-showcase__motivation">
        {renderMotivationToChange()}
      </div>
    </td>
  );
};

export default MotivationToChange;
